import { SEVERITY_LEVELS } from './constants'

import s from './styles.module.scss'

export const SEVERITY_THEMES = {
  [SEVERITY_LEVELS.LATE]: {
    badge: s.badgeFaltador,
    chip: s.severityChipFaltador,
    bar: s.barFillFaltador,
    helpText: s.helpTextLate,
  },
  [SEVERITY_LEVELS.WARNING]: {
    badge: s.badgeWarning,
    chip: s.severityChipWarning,
    bar: s.barFillWarning,
    helpText: s.helpTextWarning,
  },
  [SEVERITY_LEVELS.PUNCTUAL]: {
    badge: s.badgePunctual,
    chip: s.severityChipPunctual,
    bar: s.barFillPunctual,
    helpText: s.helpTextPunctual,
  },
  [SEVERITY_LEVELS.NO_HISTORY]: {
    badge: s.badgeNoHistory,
    chip: s.severityChipNoHistory,
    bar: s.barFillNoHistory,
    helpText: s.helpTextNoHistory,
  },
}
